// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"257":"2cf2047d","453":"6d07eec2","470":"ea592f57"}[chunkId] + ".chunk.js";
};